import React, { useState } from "react";
import Modal from "../../../components/Modal";
import Button from "../../../components/Button";
import Input from "../../../components/Input";
import { toast } from "react-toastify";
import api from "../../../services/api";
import { renderError } from "../../../helpers/errors";

// Modal de exclusão de painel com confirmação por digitação: o botão de excluir
// só habilita quando o usuário digita o nome exato do painel. Centraliza a mesma
// cópia e a mesma chamada de API usadas na lista de painéis e na página de
// edição, para que ambos os fluxos exijam a confirmação por digitação.
const PipelineDeleteModal = ({ pipeline, close, onDeleted }) => {
    const [text, setText] = useState("");
    const [deleting, setDeleting] = useState(false);

    if (!pipeline) return null;

    const confirmed = text.trim() === (pipeline.name ?? "").trim();

    const confirmDelete = () => {
        setDeleting(true);
        api.delete(`/pipeline/${pipeline.id}`).then(() => {
            toast.success("Painel excluído com sucesso");
            onDeleted();
        }).catch(error => {
            renderError(error);
        }).then(() => setDeleting(false));
    };

    return (
        <Modal
            className={`pipeline-delete-modal`}
            show={true}
            title={`Excluir painel`}
            close={() => { if (!deleting) close(); }}
            footer={
                <>
                    <Button
                        type={`primary`}
                        size={`small`}
                        svg={`delete-small-white`}
                        text={`Excluir painel`}
                        action={confirmDelete}
                        loading={deleting}
                        disabled={!confirmed}
                    />
                    {!deleting &&
                        <Button type={`secondary`} size={`small`} text={`Cancelar`} action={close} />
                    }
                </>
            }
        >
            <div className="section pipeline-delete">
                <p className="pipeline-delete__warning">
                    Esta ação é <strong>irreversível</strong>. O painel <strong>“{pipeline.name}”</strong> e todo o
                    seu conteúdo (etapas, cards e automações) deixarão de ficar acessíveis.
                </p>
                <p className="pipeline-delete__hint">
                    Para confirmar, digite o nome do painel: <strong>{pipeline.name}</strong>
                </p>
                <Input
                    value={text}
                    change={value => setText(value)}
                    placeholder={pipeline.name}
                />
            </div>
        </Modal>
    );
};

export default PipelineDeleteModal;
